// extracted by mini-css-extract-plugin
export var icon = "_r7-0";